import { identity, isEmpty, omit, pickBy } from 'lodash';

export function cleanFilters(filter) {
  const filters = pickBy(omit(filter, ['page', 'limit']), identity);
  if (isEmpty(filters.subInfos)) {
    delete filters.subInfos;
  }
  if (isEmpty(filters)) {
    return false;
  }
  return filters;
}
